import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Menu, Icon, Accordion } from 'semantic-ui-react';
import { SettingMenuContext } from './content';
import { redirectToInternalLink } from 'businessLogic/redirector';
import { queueESEvents, ESEventTypes } from 'businessLogic/logEventToElasticSearch';
import { getOURecordingSetting, getWAByIdWithSearchTerm, updateFilterValue } from 'actions/organisation';
import {
  getWaitingAreaGeneralInfo,
  getWaitingAreaLocalAccessHours,
  restoreAccessWaitingArea,
  getWaitingArea,
  updateWaitingAreaForm,
  getBeforeCallsInfo,
  getBeforeCallsImportantInfo,
  getWaitingAreaOperatingHours,
  getWaitingAreaCallerEntryPoint,
  updateCallerEntryPointForm,
  getDuringCallsInfo,
  checkIsRecordingAvailableOnPortal,
  getAfterCallsInfo,
  getWaitingAreaLogoPauseImage,
  getSupportContactInfo,
  getWaitingAreaInfoForCallers,
  selectWaitingAreaEntity,
  getWaitingAreaShareLinkMessage,
  getWARecordingSetting,
  getGCWASettings,
} from '../../../../actions/waitingArea.js';
import {
  updateShowUpdateWaitingAreaLocalAccessHoursModal,
  updateShowViewWaitingAreaLocalAccessHoursModal,
  updateShowUpdateWaitingAreaModal,
  updateShowViewWaitingAreaModal,
  updateShowSuspendWAModal,
  updateShowUpdateWaitingAreaOperatingHoursModal,
  updateShowViewWaitingAreaOperatingHoursModal,
  updateShowWaitingAreaBeforeCallsModal,
  updateShowWaitingAreaBeforeCallsImportantInfoModal,
  showCallerEntryModal,
  showWaitingAreaDuringCallsModal,
  showWaitingAreaAfterCallsModal,
  showWaitingAreaLogoPauseImageModal,
  showDeleteWaitingAreaModal,
  showSupportContactModal,
  showInfoForCallersModal,
  showWAShareLinkMessageModal,
  showConsultNowSettingModal,
  showWAAudioSettingModal,
  showGCSettingsModal,
  showOuWaGcSettingsModal,
} from 'actions/modal';
import { previousPage } from 'actions/navigationBar';
import { NetworkTypes } from '../../../../constants/networkTypes.js';

// Waiting area level admin functions
function showSuspendWaitingAreaModal(waitingArea, dispatch) {
  dispatch(updateShowSuspendWAModal(true));
}

function manageWaitingAreaUsers(waitingArea, filterValue, dispatch) {
  dispatch(updateFilterValue(filterValue));
  redirectToInternalLink('waiting-area/manage-users/' + waitingArea.id);
}

function manageWaitingAreaTags(waitingArea, filterValue, dispatch) {
  dispatch(updateFilterValue(filterValue));
  redirectToInternalLink('waiting-area/manage-tags/' + waitingArea.id);
}

function viewWaitingAreaGeneral(waitingArea, dispatch) {
  let cb = (data) => {
    dispatch(selectWaitingAreaEntity(data));
    dispatch(updateShowViewWaitingAreaModal(true));
  };
  queueESEvents(
    ESEventTypes.APICall,
    `In viewWaitingAreaGeneral: ${waitingArea.id}`,
    'eventType&apiURL',
    {
      apiURL: window.APP.CONFIGURATION.VCCAPI + 'waitingareas/' + waitingArea.id + '/calls',
      browserURL: window.location.href,
    },
    null,
    true,
    'info'
  );
  dispatch(getWaitingArea(waitingArea.id, cb));
}

function editWaitingAreaGeneral(waitingArea, dispatch) {
  let cb = (data) => {
    dispatch(updateShowUpdateWaitingAreaModal(true));
    dispatch(updateWaitingAreaForm(data));
  };
  dispatch(getWaitingAreaGeneralInfo(waitingArea.id, cb));
}

function viewWaitingAreaOperatingHoursGeneral(waitingArea, dispatch) {
  let cb = () => {
    dispatch(updateShowViewWaitingAreaOperatingHoursModal(true));
  };
  dispatch(getWaitingAreaOperatingHours(waitingArea.id, cb));
}

function openWaitingAreaBeforeCalls(waitingArea, dispatch) {
  let cb = (data) => {
    dispatch(updateShowWaitingAreaBeforeCallsModal(true));
  };
  dispatch(getBeforeCallsInfo(waitingArea.id, cb));
}

function openWaitingAreaBeforeCallsImportantInfo(waitingArea, dispatch) {
  let cb = (data) => {
    dispatch(updateShowWaitingAreaBeforeCallsImportantInfoModal(true));
  };
  dispatch(getBeforeCallsImportantInfo(waitingArea.id, cb));
}

function editWaitingAreaOperatingHoursGeneral(waitingArea, dispatch) {
  let cb = (data) => {
    dispatch(updateShowUpdateWaitingAreaOperatingHoursModal(true));
  };
  dispatch(getWaitingAreaOperatingHours(waitingArea.id, cb));
}

function viewWaitingAreaLocalAccessHoursGeneral(waitingArea, dispatch) {
  let cb = () => {
    dispatch(updateShowViewWaitingAreaLocalAccessHoursModal(true));
  };
  dispatch(getWaitingAreaLocalAccessHours(waitingArea.id, cb));
}

function editWaitingAreaLocalAccessHoursGeneral(waitingArea, dispatch) {
  let cb = (data) => {
    dispatch(updateShowUpdateWaitingAreaLocalAccessHoursModal(true));
  };
  dispatch(getWaitingAreaLocalAccessHours(waitingArea.id, cb));
}

function viewEditLogoPauseImageAccess(waitingArea, dispatch) {
  let cb = () => {
    dispatch(showWaitingAreaLogoPauseImageModal(true));
  };
  dispatch(getWaitingAreaLogoPauseImage(waitingArea.id, cb));
}

function restoreAccessWA(waitingArea, dispatch) {
  let cb = () => {
    let lastDb = (data) => {
      dispatch(selectWaitingAreaEntity(data));
    };
    dispatch(getWAByIdWithSearchTerm(waitingArea.id, waitingArea.orgNetworkId, lastDb));
  };
  dispatch(restoreAccessWaitingArea(waitingArea, cb));
}

function openWaitingAreaDuringCalls(waitingArea, dispatch) {
  let cb = (data) => {
    dispatch(showWaitingAreaDuringCallsModal(true));
  };
  dispatch(getDuringCallsInfo(waitingArea.id, cb));
  dispatch(checkIsRecordingAvailableOnPortal());
}

function openWaitingAreaCallerEntryPoint(waitingArea, dispatch) {
  let cb = (data) => {
    dispatch(updateCallerEntryPointForm(data));
    dispatch(showCallerEntryModal(true));
  };
  let firstCb = (data) => {
    dispatch(selectWaitingAreaEntity(data, cb));
    dispatch(getWaitingAreaCallerEntryPoint(waitingArea.id, cb));
  };
  queueESEvents(
    ESEventTypes.APICall,
    `In openWaitingAreaCallerEntryPoint: ${waitingArea.id}`,
    'eventType&apiURL',
    {
      apiURL: window.APP.CONFIGURATION.VCCAPI + 'waitingareas/' + waitingArea.id + '/calls',
      browserURL: window.location.href,
    },
    null,
    true,
    'info'
  );
  dispatch(getWaitingArea(waitingArea.id, firstCb));
}

function openWaitingAreaAfterCalls(waitingArea, dispatch) {
  let cb = (data) => {
    dispatch(showWaitingAreaAfterCallsModal(true));
  };
  dispatch(getAfterCallsInfo(waitingArea.id, cb));
}
function openConsultNowSetting(waID, dispatch) {
  let cb = (data) => {
    dispatch(showConsultNowSettingModal(true));
  };
  dispatch(getWaitingArea(waID, cb));
}
function openAudioRecordingSetting(waID, dispatch) {
  let cb = (data) => {
    dispatch(showWAAudioSettingModal(true));
  };
  dispatch(getWARecordingSetting(waID, cb));
}
function openDeleteWaitingArea(waitingArea, dispatch) {
  let cb = (data) => {
    dispatch(selectWaitingAreaEntity(data));
    dispatch(showDeleteWaitingAreaModal(true));
  };
  queueESEvents(
    ESEventTypes.APICall,
    `In openDeleteWaitingArea: ${waitingArea.id}`,
    'eventType&apiURL',
    {
      apiURL: window.APP.CONFIGURATION.VCCAPI + 'waitingareas/' + waitingArea.id + '/calls',
      browserURL: window.location.href,
    },
    null,
    true,
    'info'
  );
  dispatch(getWaitingArea(waitingArea.id, cb));
}

function openSupportContact(waitingArea, dispatch) {
  let cb = (data) => {
    dispatch(showSupportContactModal(true));
  };
  dispatch(getSupportContactInfo(waitingArea.id, cb));
}

function openInfoForCallers(waitingArea, dispatch) {
  let cb = (data) => {
    dispatch(showInfoForCallersModal(true));
  };

  dispatch(getWaitingAreaInfoForCallers(waitingArea.id, cb));
}

function openWAShareLinkMessage(waitingArea, dispatch) {
  let cb = (data) => {
    dispatch(showWAShareLinkMessageModal(true));
  };

  dispatch(getWaitingAreaShareLinkMessage(waitingArea.id, cb));
}

function editGCWASettings(waitingArea, dispatch) {
  let cb = () => {
    dispatch(showGCSettingsModal(true));
  };
  dispatch(getGCWASettings(waitingArea.id, cb));
}

// WA setting menu
export default function WASettingMenu(props) {
  const dispatch = useDispatch();
  const { waSetting, selectedWaitingArea, entityFilter, openSubMenu, selectedOrgUnit } = useContext(SettingMenuContext);
  const [openWASettingMenu, setOpenWASettingMenu] = waSetting;
  const [settingSubMenuActiveIndex, setSettingSubMenuActiveIndex] = openSubMenu;
  const [filterValue, setFilterValue] = entityFilter;

  let hasManageWaitingAreaAccess = false;
  let hasEditWaitingAreaAccess = false;
  let hasViewWaitingAreaAccess = false;
  let hasManageRolesAccess = false;
  let hasViewTagsAccess = false;
  const isFullNameFeatureEnabled = props.isFullNameFeatureEnabled;
  const isChatFeatureEnabled = props.isChatFeatureEnabled;

  if (selectedWaitingArea && selectedWaitingArea.permissions && selectedWaitingArea.permissions.length > 0) {
    hasManageWaitingAreaAccess = selectedWaitingArea.permissions.indexOf('MANAGE_ACCESS') > -1;
    hasEditWaitingAreaAccess = selectedWaitingArea.permissions.indexOf('EDIT') > -1;
    hasViewWaitingAreaAccess = selectedWaitingArea.permissions.indexOf('VIEW') > -1;
    hasManageRolesAccess = selectedWaitingArea.permissions.indexOf('MANAGE_MEMBER_ROLES') > -1;
    hasViewTagsAccess =
      selectedWaitingArea.reportingTagsEnabled && selectedWaitingArea.permissions.indexOf('VIEW_ASSIGNED_TAGS') > -1;
  }

  const subMenu = (
    <Menu vertical className="color-white new-advanced-settings-menu color-waiting-area-dark-bg pdbm mrtnull">
      {hasViewWaitingAreaAccess && hasEditWaitingAreaAccess && (
        <Menu.Item
          className="standard-menu-font-size"
          onClick={() => {
            editWaitingAreaGeneral(selectedWaitingArea, dispatch);
          }}
        >
          {APP.LANGUAGE.ViewOneWaitingArea.EditProperties}
        </Menu.Item>
      )}
      {hasViewWaitingAreaAccess &&
        hasEditWaitingAreaAccess &&
        (isFullNameFeatureEnabled || isChatFeatureEnabled) &&
        selectedWaitingArea.networkTypeId == NetworkTypes.GroupConsultation && (
          <Menu.Item
            className="standard-menu-font-size"
            onClick={() => {
              editGCWASettings(selectedWaitingArea, dispatch);
            }}
          >
            {APP.LANGUAGE.ViewOneWaitingArea.GCSettings}
          </Menu.Item>
        )}
      {hasViewWaitingAreaAccess && hasEditWaitingAreaAccess && (
        <Menu.Item
          className="standard-menu-font-size"
          onClick={() => {
            openSupportContact(selectedWaitingArea, dispatch);
          }}
        >
          {APP.LANGUAGE.ViewOneWaitingArea.SupportContact}
        </Menu.Item>
      )}
      {hasViewWaitingAreaAccess && hasEditWaitingAreaAccess && (
        <Menu.Item
          className="standard-menu-font-size"
          onClick={() => {
            openInfoForCallers(selectedWaitingArea, dispatch);
          }}
        >
          {APP.LANGUAGE.ViewOneWaitingArea.CallerSupportInfo}
        </Menu.Item>
      )}
      {hasViewWaitingAreaAccess && hasEditWaitingAreaAccess && (
        <Menu.Item
          className="standard-menu-font-size"
          onClick={() => {
            viewEditLogoPauseImageAccess(selectedWaitingArea, dispatch);
          }}
        >
          {APP.LANGUAGE.ViewOneWaitingArea.ViewLogoPauseImageAccess}
        </Menu.Item>
      )}
      {hasViewWaitingAreaAccess && hasEditWaitingAreaAccess && (
        <Menu.Item
          className="standard-menu-font-size"
          onClick={() => {
            editWaitingAreaOperatingHoursGeneral(selectedWaitingArea, dispatch);
          }}
        >
          {APP.LANGUAGE.ViewOneWaitingArea.EditLocalVideoCallAccess}
        </Menu.Item>
      )}
      {props.entityAdminRights.isAdmin && hasViewWaitingAreaAccess && hasEditWaitingAreaAccess && (
        <Menu.Item
          className="standard-menu-font-size"
          onClick={() => {
            editWaitingAreaLocalAccessHoursGeneral(selectedWaitingArea, dispatch);
          }}
        >
          {APP.LANGUAGE.ViewOneWaitingArea.EditLocalVideoCallAccessHours}
        </Menu.Item>
      )}
      {hasViewWaitingAreaAccess && hasEditWaitingAreaAccess && (
        <Menu.Item
          className="standard-menu-font-size"
          onClick={() => {
            openWaitingAreaCallerEntryPoint(selectedWaitingArea, dispatch);
          }}
        >
          {APP.LANGUAGE.ViewOneWaitingArea.CallerEntry}
        </Menu.Item>
      )}
      {props.WAOURecordingEnable &&
        hasViewWaitingAreaAccess &&
        hasEditWaitingAreaAccess &&
        selectedWaitingArea.networkTypeId !== NetworkTypes.GroupConsultation && (
          <Menu.Item
            className="standard-menu-font-size"
            onClick={() => {
              openAudioRecordingSetting(selectedWaitingArea.id, dispatch);
            }}
          >
            {APP.LANGUAGE.ViewOneWaitingArea.AudioRecording}
          </Menu.Item>
        )}
      {hasViewWaitingAreaAccess && hasEditWaitingAreaAccess && props.isWAEntryPointAdditionalMsgAllowed && (
        <Menu.Item
          className="standard-menu-font-size"
          onClick={() => {
            openWAShareLinkMessage(selectedWaitingArea, dispatch);
          }}
        >
          {APP.LANGUAGE.ViewOneWaitingArea.WaitingAreasShareLink}
        </Menu.Item>
      )}
      {hasViewWaitingAreaAccess && hasEditWaitingAreaAccess && (
        <Menu.Item
          className="standard-menu-font-size"
          onClick={() => {
            openWaitingAreaBeforeCalls(selectedWaitingArea, dispatch);
          }}
        >
          {APP.LANGUAGE.ViewOneWaitingArea.BeforeCallsCallers}
        </Menu.Item>
      )}
      {hasViewWaitingAreaAccess && hasEditWaitingAreaAccess && (
        <Menu.Item
          className="standard-menu-font-size"
          onClick={() => {
            openWaitingAreaBeforeCallsImportantInfo(selectedWaitingArea, dispatch);
          }}
        >
          {APP.LANGUAGE.ViewOneWaitingArea.BeforeCallsImportantInfo}
        </Menu.Item>
      )}
      {hasViewWaitingAreaAccess &&
        hasEditWaitingAreaAccess &&
        selectedWaitingArea.networkTypeId !== NetworkTypes.GroupConsultation && (
          <Menu.Item
            className="standard-menu-font-size"
            onClick={() => {
              openWaitingAreaDuringCalls(selectedWaitingArea, dispatch);
            }}
          >
            {APP.LANGUAGE.ViewOneWaitingArea.DuringCalls}
          </Menu.Item>
        )}
      {hasViewWaitingAreaAccess && hasEditWaitingAreaAccess && (
        <Menu.Item
          className="standard-menu-font-size"
          onClick={() => {
            openWaitingAreaAfterCalls(selectedWaitingArea, dispatch);
          }}
        >
          {APP.LANGUAGE.ViewOneWaitingArea.AfterCalls}
        </Menu.Item>
      )}
      {hasViewWaitingAreaAccess && !hasEditWaitingAreaAccess && (
        <Menu.Item
          className="standard-menu-font-size"
          onClick={() => {
            viewWaitingAreaGeneral(selectedWaitingArea, dispatch);
          }}
        >
          {APP.LANGUAGE.ViewOneWaitingArea.ViewProperties}
        </Menu.Item>
      )}
      {hasViewWaitingAreaAccess &&
        !hasEditWaitingAreaAccess &&
        (isFullNameFeatureEnabled || isChatFeatureEnabled) &&
        selectedWaitingArea.networkTypeId == NetworkTypes.GroupConsultation && (
          <Menu.Item
            className="standard-menu-font-size"
            onClick={() => {
              editGCWASettings(selectedWaitingArea, dispatch);
            }}
          >
            {APP.LANGUAGE.ViewOneWaitingArea.GCSettings}
          </Menu.Item>
        )}
      {hasViewWaitingAreaAccess && !hasEditWaitingAreaAccess && (
        <Menu.Item
          className="standard-menu-font-size"
          onClick={() => {
            openSupportContact(selectedWaitingArea, dispatch);
          }}
        >
          {APP.LANGUAGE.ViewOneWaitingArea.SupportContact}
        </Menu.Item>
      )}
      {hasViewWaitingAreaAccess && !hasEditWaitingAreaAccess && (
        <Menu.Item
          className="standard-menu-font-size"
          onClick={() => {
            openInfoForCallers(selectedWaitingArea, dispatch);
          }}
        >
          {APP.LANGUAGE.ViewOneWaitingArea.CallerSupportInfo}
        </Menu.Item>
      )}
      {hasViewWaitingAreaAccess && !hasEditWaitingAreaAccess && (
        <Menu.Item
          className="standard-menu-font-size"
          onClick={() => {
            viewEditLogoPauseImageAccess(selectedWaitingArea, dispatch);
          }}
        >
          {APP.LANGUAGE.ViewOneWaitingArea.ViewLogoPauseImageAccess}
        </Menu.Item>
      )}
      {hasViewWaitingAreaAccess && !hasEditWaitingAreaAccess && (
        <Menu.Item
          className="standard-menu-font-size"
          onClick={() => {
            openWaitingAreaCallerEntryPoint(selectedWaitingArea, dispatch);
          }}
        >
          {APP.LANGUAGE.ViewOneWaitingArea.CallerEntry}
        </Menu.Item>
      )}
      {hasViewWaitingAreaAccess && !hasEditWaitingAreaAccess && (
        <Menu.Item
          className="standard-menu-font-size"
          onClick={() => {
            openWaitingAreaBeforeCalls(selectedWaitingArea, dispatch);
          }}
        >
          {APP.LANGUAGE.ViewOneWaitingArea.BeforeCallsCallers}
        </Menu.Item>
      )}
      {hasViewWaitingAreaAccess && !hasEditWaitingAreaAccess && (
        <Menu.Item
          className="standard-menu-font-size"
          onClick={() => {
            openWaitingAreaBeforeCallsImportantInfo(selectedWaitingArea, dispatch);
          }}
        >
          {APP.LANGUAGE.ViewOneWaitingArea.BeforeCallsImportantInfo}
        </Menu.Item>
      )}
      {hasViewWaitingAreaAccess &&
        !hasEditWaitingAreaAccess &&
        selectedWaitingArea.networkTypeId !== NetworkTypes.GroupConsultation && (
          <Menu.Item
            className="standard-menu-font-size"
            onClick={() => {
              openWaitingAreaDuringCalls(selectedWaitingArea, dispatch);
            }}
          >
            {APP.LANGUAGE.ViewOneWaitingArea.DuringCalls}
          </Menu.Item>
        )}
      {hasEditWaitingAreaAccess &&
        props.isConsultNowFeatureEnabled &&
        selectedWaitingArea.networkTypeId !== NetworkTypes.GroupConsultation && (
          <Menu.Item
            className="standard-menu-font-size"
            onClick={() => {
              openConsultNowSetting(selectedWaitingArea.id, dispatch);
            }}
          >
            {APP.LANGUAGE.ViewOneWaitingArea.EnableConsultNow}
          </Menu.Item>
        )}
      {hasViewWaitingAreaAccess && !hasEditWaitingAreaAccess && (
        <Menu.Item
          className="standard-menu-font-size"
          onClick={() => {
            openWaitingAreaAfterCalls(selectedWaitingArea, dispatch);
          }}
        >
          {APP.LANGUAGE.ViewOneWaitingArea.AfterCalls}
        </Menu.Item>
      )}
    </Menu>
  );

  return (
    <React.Fragment>
      {openWASettingMenu && (
        <div id="entity-admin-setting-menu" className="advanced-settings">
          <Menu
            className="new-advanced-settings-menu color-waiting-area-bg pdbnull take-remain-space flex-direction-column"
            vertical
          >
            <Menu.Header
              className={
                'inline-flex center-flex pdtm space-between max-width new-advanced-settings-menu_header--wa ' +
                (props.isOnMobileOrTablet ? 'pdlm pdrm pdtm pdbm' : '')
              }
            >
              <div>
                <div className={'color-white mrrs ' + (!props.isOnMobileOrTablet ? 'pdll' : 'mrbxxs')}>
                  {APP.LANGUAGE.EntityAdmin.WaitingArea}
                </div>
                <Link
                  className={
                    'color-white bold setting-menu-header wrap-link ' +
                    (!props.isOnMobileOrTablet ? 'pdll pdts pdbs pdrl' : 'mrrs')
                  }
                  to={`/waiting-area/view-one/${selectedWaitingArea.id}`}
                  onClick={() => {
                    dispatch(previousPage(APP.LANGUAGE.ViewAllOrgUnit.Title));
                  }}
                >
                  {APP.LANGUAGE.EntityAdmin.Settings.replace('##entityName##', selectedWaitingArea.name)}
                  <Icon name="chevron circle right" className="chevron-circle-right pdlm" />
                </Link>
              </div>
              {props.isOnMobileOrTablet ? (
                <div className="pdxs hand" onClick={props.closeMenu}>
                  <Icon name="cancel" className="color-footer-links mrrnull close-menu-icon" size="large" />
                </div>
              ) : (
                <></>
              )}
            </Menu.Header>
            {hasManageWaitingAreaAccess && !selectedWaitingArea.isSuspended && (
              <Menu.Item
                className={
                  props.isOnMobileOrTablet ? 'standard-menu-font-size pdlm pdrm pdtm pdbm' : 'standard-menu-font-size'
                }
                onClick={() => {
                  showSuspendWaitingAreaModal(selectedWaitingArea, dispatch);
                }}
              >
                {APP.LANGUAGE.ViewOneWaitingArea.SuspendAccess}
              </Menu.Item>
            )}
            {hasManageWaitingAreaAccess && selectedWaitingArea.isSuspended && (
              <Menu.Item
                className={
                  props.isOnMobileOrTablet ? 'standard-menu-font-size pdlm pdrm pdtm pdbm' : 'standard-menu-font-size'
                }
                onClick={() => {
                  restoreAccessWA(selectedWaitingArea, dispatch);
                }}
              >
                {APP.LANGUAGE.ViewOneWaitingArea.RestoreAccess}
              </Menu.Item>
            )}
            {hasManageRolesAccess && (
              <Menu.Item
                className={
                  props.isOnMobileOrTablet ? 'standard-menu-font-size pdlm pdrm pdtm pdbm' : 'standard-menu-font-size'
                }
                onClick={() => {
                  manageWaitingAreaUsers(selectedWaitingArea, filterValue, dispatch);
                }}
              >
                {APP.LANGUAGE.ViewOneWaitingArea.ManageUsers}
              </Menu.Item>
            )}
            {hasViewTagsAccess && (
              <Menu.Item
                className={
                  props.isOnMobileOrTablet ? 'standard-menu-font-size pdlm pdrm pdtm pdbm' : 'standard-menu-font-size'
                }
                onClick={() => {
                  manageWaitingAreaTags(selectedWaitingArea, filterValue, dispatch);
                }}
              >
                {APP.LANGUAGE.ViewOneWaitingArea.ManageTags}
              </Menu.Item>
            )}
            {hasViewWaitingAreaAccess && hasEditWaitingAreaAccess && (
              <Menu.Item
                className={
                  props.isOnMobileOrTablet ? 'standard-menu-font-size pdlm pdrm pdtm pdbm' : 'standard-menu-font-size'
                }
                onClick={() => {
                  openDeleteWaitingArea(selectedWaitingArea, dispatch);
                }}
              >
                {APP.LANGUAGE.ViewOneWaitingArea.DeleteWaitingArea}
              </Menu.Item>
            )}
            {hasViewWaitingAreaAccess || hasEditWaitingAreaAccess ? (
              <Accordion
                as={Menu}
                vertical
                className="mrtnull new-advanced-settings-menu color-waiting-area-bg pdbnull take-remain-space flex-direction-column"
              >
                <Menu.Item className="pdlnull pdrnull pdbnull pdtnull take-remain-space flex-direction-column">
                  <Accordion.Title
                    className={
                      'color-white standard-menu-font-size menu-item-wa ' +
                      (props.isOnMobileOrTablet ? 'pdlm pdrm' : 'pdll pdrl')
                    }
                    active={settingSubMenuActiveIndex === 0}
                    index={0}
                    onClick={props.handleClick}
                  >
                    {APP.LANGUAGE.ViewOrgUnit.Properties}
                    {settingSubMenuActiveIndex === 0 ? (
                      <Icon name="angle up" className="arrow-rotate-up fr" />
                    ) : (
                      <Icon name="angle down" className="arrow-rotate-down fr" />
                    )}
                  </Accordion.Title>
                  <Accordion.Content
                    className={'pdtnull ' + (settingSubMenuActiveIndex === 0 ? 'take-remain-space' : '')}
                    active={settingSubMenuActiveIndex === 0}
                    content={subMenu}
                  />
                </Menu.Item>
              </Accordion>
            ) : (
              ''
            )}
          </Menu>
        </div>
      )}
    </React.Fragment>
  );
}
